module.exports = __webpack_public_path__ + "assets/img/station24.9decf25c.png";